/**
 * ============================================================
 * Layer Manager
 * ============================================================
 */

import AppState from "../core/app.js";

class LayerManager {
    add(name, type, layer, bounds) {
        const item = {
            id: crypto.randomUUID(),

            name,

            type,

            visible: true,

            layer,

            bounds,
        };

        AppState.layers.imported.push(item);

        return item;
    }

    getAll() {
        return AppState.layers.imported;
    }

    get(id) {
        return AppState.layers.imported.find((layer) => layer.id === id);
    }

    remove(id) {
        const item = this.get(id);

        if (!item) return false;

        if (item.layer && AppState.map.hasLayer(item.layer)) {
            AppState.map.removeLayer(item.layer);
        }

        AppState.layers.imported = AppState.layers.imported.filter((layer) => layer.id !== id);

        console.log(`Layer "${item.name}" removed.`);

        return true;
    }

    setVisible(id, visible) {
        const item = this.get(id);

        if (!item) return;

        item.visible = visible;

        if (visible) {
            AppState.map.addLayer(item.layer);
        } else {
            AppState.map.removeLayer(item.layer);
        }
    }

    zoom(id) {
        const item = this.get(id);

        if (!item) return;

        if (item.bounds && item.bounds.isValid()) {
            AppState.map.fitBounds(item.bounds);
        }
    }
}

export default new LayerManager();
